export default function getTimeAsPercentageOfDay(time, day) {
    if (time.isBefore(day))
        return 0;
    if (time.isAfter(day.endOf('day')))
        return 100;
    const minutes = time.hour() * 60 + time.minute();
    const result = (minutes / 1440) * 100;
    return result;
}
